<template>
  <li>
		<router-link :to="{ name: 'invoices.show', params: { id: invoice.id }}">
			<span class="invoice-status" :class="invoice.status_class" data-toggle="tooltip" data-placement="top" :title="invoice.status_text">{{ invoice.status_letter }}</span>
			<div class="row">
				<div class="col-lg-4">
					<h2 class="truncate"><strong>Invoice {{ invoice.xero_number }}</strong> - {{ invoice.user_name }}.</h2>
				</div>
				<div class="col-lg-8">
					<ul class="breakdown">
						<li><span>Invoiced:</span> {{ invoice.total_with_gst }}</li>
						<li><span>Paid:</span> {{ invoice.paid }}</li>
						<li v-if="invoice.isNotPaid" class="due"><span>Due:</span> {{ invoice.remaining }}</li>
						<li v-else><span class="text-success"><strong>PAID</strong></span></li>
					</ul>
				</div>
			</div><!-- /.row -->
			<ul class="details">
				<li><span>Created:</span> {{ invoice.created_date }}</li>
				<li><span>Due:</span> {{ invoice.due_date }}</li>
				<li><span>Reference:</span> {{ invoice.order_reference }}</li>
			</ul>
		</router-link>
	</li>
</template>

<script>
  export default {
    props: ['invoice']
  }
</script>



// WEBPACK FOOTER //
// InvoiceItem.vue?95521da4